(function () {
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var btn = target.closest('[data-quantity-plus], [data-quantity-minus]');
    if (!btn) return;

    var selector = btn.closest('[data-quantity-selector]');
    if (!selector) return;

    var input = selector.querySelector('[data-quantity-input]');
    if (!input) return;

    var valueBefore = input.value;

    setTimeout(function () {
      if (input.value !== valueBefore) return;

      var isPlus = btn.matches('[data-quantity-plus]');
      var step = parseInt(input.dataset.incrementValue, 10) || 1;
      var current = parseInt(input.value, 10);
      if (isNaN(current)) current = step;

      var newValue = isPlus ? current + step : Math.max(step, current - step);
      input.value = newValue;

      var minusWrapper = selector.querySelector('[data-button-wrapper-minus]');
      if (minusWrapper) {
        if (newValue <= step) {
          minusWrapper.classList.add('quantity-selector__button-wrapper--disabled');
        } else {
          minusWrapper.classList.remove('quantity-selector__button-wrapper--disabled');
        }
      }

      input.dispatchEvent(new Event('change', { bubbles: true }));
    }, 0);
  }, false);
})();
